import React, { useCallback, useEffect, useState } from 'react'
import { CardTable, SORT } from 'common/components/datatable/Table'
import useTitles from 'common/hooks/useTitles'
import useActions from 'common/hooks/useActions'
import { NEW } from 'common/components/action/ActionConstant'
import { aquaFetch } from 'common/utils/ActionUtils'
import ApplicationConf from 'conf/ApplicationConf'
import { ExportAction } from 'common/utils/ExportUtils'
import { isNil } from 'lodash'
import { toast } from 'react-toastify'
import ConfirmModal from 'common/components/modal/ConfirmModal'
import useBoolean from 'common/hooks/useBoolean'
import ContactFormDialog from 'gdl/customer/components/contributor/ContactFormDialog'

const HEADERS = [
    { key: 'name', value: 'Nom' },
    { key: 'login', value: 'Login Aquasys' },
    { key: 'email', value: 'Email' },
    { key: 'telephone', value: 'Téléphone' },
    { key: 'description', value: 'Description' },
]

const ContactsListApp = () => {
    const [contacts, setContacts] = useState([])
    const [editContact, setEditContact] = useState(undefined)
    const [contactToDelete, setContactToDelete] = useState(undefined)
    const { value: formOpen, setTrue: openForm, setFalse: closeForm } = useBoolean(false)

    useTitles(() => [{
        label: 'Contacts',
        href: '/customer/contacts',
    }], [])

    const reload = useCallback(() => {
        aquaFetch(ApplicationConf.gdl.contacts())
            .then(res => setContacts(res ?? []))
            .catch(() => toast.error('Erreur lors du chargement des contacts'))
    }, [])

    useEffect(() => {
        reload()
    }, [reload])

    useActions(() => [{
        type: NEW,
        onClick: () => {
            setEditContact(undefined)
            openForm()
        },
    }], [])

    const onDelete = () => {
        aquaFetch(ApplicationConf.gdl.contact(contactToDelete.idContact), { method: 'DELETE' })
            .then(() => {
                reload()
                setContactToDelete(undefined)
            })
            .catch(() => toast.error('Suppression impossible : contact encore rattaché à un client'))
    }

    return (
        <>
            <CardTable
                title='Contacts'
                color='#161832'
                rows={contacts}
                headers={HEADERS}
                onClickRow={(row) => {
                    setEditContact(row); openForm()
                }}
                contextActions={(row) => [
                    { label: 'Modifier', icon: 'edit', onClick: () => {
                        setEditContact(row); openForm()
                    } },
                    { label: 'Supprimer', icon: 'delete', color: 'red', onClick: () => setContactToDelete(row) },
                ]}
                defaultSort={{ column: 'name', direction: SORT.ASC }}
                actions={[{
                    icon: 'download',
                    tooltip: 'Exporter',
                    displayed: contacts.length > 0,
                    onClick: () => ExportAction.exportData(contacts, 'Contacts'),
                }]}
            />
            {formOpen && (
                <ContactFormDialog
                    contact={editContact}
                    onClose={closeForm}
                    onSaved={reload}
                />
            )}
            <ConfirmModal
                isOpen={!isNil(contactToDelete)}
                title={`Supprimer le contact « ${contactToDelete?.name ?? ''} » ?`}
                onValidate={onDelete}
                onClose={() => setContactToDelete(undefined)}
            />
        </>
    )
}

export default ContactsListApp
